module.exports = __webpack_public_path__ + "img/40x40-paper-doc.69742015.svg";